import { createLucideIcon } from 'lucide-react';
export const ArrowCircleRight = createLucideIcon('arrow-circle-right', [
  [
    'path',
    {
      d: 'M18 11.8324L14.5 16',
      key: '3spoi0',
    },
  ],
  [
    'path',
    {
      d: 'M18 11.8324L14.5 8',
      key: 'ztspo7',
    },
  ],
  [
    'path',
    {
      d: 'M6 11.8324H18',
      key: '1o22dp',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
